import axios from 'axios';
import { useQuery } from 'react-query';

import { i18nInstance } from '../../translations';
import { isProd } from '../../util/env';

import type { UseQueryResult } from 'react-query';

const url = `https://graphql.contentful.com/content/v1/spaces/hu5zbimv1zds`;

export const shouldShowPreview = (): boolean => {
  if (isProd) {
    return false;
  }
  const preview = new URLSearchParams(window.location.search).get('preview');
  return !!preview;
};

export const useContentfulQuery = async <ContentType>(graphqlQuery: string): Promise<ContentType> => {
  const isShowingPreview = shouldShowPreview();
  const client = axios.create({
    baseURL: url,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${
        isShowingPreview
          ? window.insify_runtime_config.CONTENTFUL_PREVIEW_API_KEY
          : window.insify_runtime_config.CONTENTFUL_API_KEY
      }`,
    },
  });

  return (
    await client.post(url, {
      query: graphqlQuery,
      variables: {
        preview: isShowingPreview,
        locale: i18nInstance.language,
      },
    })
  ).data.data;
};

/** check available queries at https://graphql.contentful.com/content/v1/spaces/hu5zbimv1zds/explore?access_token=aTr12yrUimV1AUBoL_XMcvRmDcZeQK0hJKjU5wY1sCA  */
export const useContentful = <ContentType>(
  queryKey: string,
  graphqlQuery: string,
  enabled = true,
): UseQueryResult<ContentType, unknown> => {
  return useQuery<ContentType>(
    queryKey,
    async (): Promise<ContentType> => {
      return useContentfulQuery(graphqlQuery);
    },
    {
      staleTime: Infinity,
      enabled,
    },
  );
};
